import React from 'react';
import type { WeddingPropType } from '../types';

function RightNameSection({ wedding }: { wedding: WeddingPropType }): JSX.Element {
  return (
    <div className="name-section-right">
      <h2 className="partner-2-name">
        {wedding.partner_first_name && (
          <span className="first-name">
            <span className="first-initial">{wedding.partner_first_name[0]}</span>
            <span className="full-first-name">
              {wedding.partner_first_name.slice(1, wedding.partner_first_name.length)}
            </span>
          </span>
        )}
        {wedding.partner_last_name && (
          <span className="last-name">
            <span className="last-initial"> {wedding.partner_last_name[0]}</span>
            <span className="full-last-name">
              {wedding.partner_last_name.slice(1, wedding.partner_last_name.length)}
            </span>
          </span>
        )}
      </h2>
    </div>
  );
}

export default RightNameSection;
